import Link from "next/link";

export function AuthAlternative(props: {
  leadText: string;
  cta: {
    href: string;
    text: string;
    trackEventID?: string;
  };
}) {
  return (
    <div className="flex flex-col gap-6 w-full">
      <div className="flex justify-center gap-2 items-center w-full">
        <hr className="border border-gray-200 w-full" />
        <div className="flex-shrink-0 text-gray-300 text-13r">또는</div>
        <hr className="border border-gray-200 w-full" />
      </div>
      <div className="flex items-center gap-2 text-gray-500">
        <div className="text-14r">{props.leadText}</div>
        <Link href={props.cta.href}>
          <div
            id={props.cta.trackEventID}
            className="underline cursor-pointer text-14m"
          >
            {props.cta.text}
          </div>
        </Link>
      </div>
    </div>
  );
}
